module.exports = "<p>\r\n  image-help works!\r\n</p>\r\n"